<div class="ranking-prize-container">
  <div class="prize-container">
    <div class="prize-title">
      <slotcom-p
        [bold]="true"
        [text]="'home.ranking.reward.remaining' | translate"
        [fontSize]="1.3"
        [shadowBorder]="true"></slotcom-p>
    </div>
    <div class="prize-display">
      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="date"
        (expired)="finished = true">
      </slotcom-animated-timer>
    </div>
  </div>
</div>
@if (isAwardPending && award()) {
  <div class="award-pending">
    <div class="title">
      <slotcom-p
        [bold]="true"
        [text]="'home.ranking.reward.current' | translate"
        [fontSize]="1.3"
        [shadowBorder]="true"></slotcom-p>
    </div>
    <div class="reward">
      <div class="display">
        <div class="display-img"></div>
        @if (award()!.prize.credits > 0) {
          <slotcom-p
            [bold]="true"
            class="display-text"
            [text]="award()!.prize.credits | number: '1.0-0' : ('common.culture' | translate)"></slotcom-p>
        }
        @if (award()!.prize.gems > 0) {
          <slotcom-p
            [bold]="true"
            class="display-text"
            [text]="award()!.prize.gems | number: '1.0-0' : ('common.culture' | translate)"></slotcom-p>
        }
      </div>
      <div class="collect-reward-button">
        <slotcom-button
          class="c-button--pink"
          (safeClick)="redeemAward()"
          [isLoading]="isRedeeming()"
          audioType="reward">
          {{ 'common.collect' | translate | uppercase }}
        </slotcom-button>
      </div>
    </div>
  </div>
}
